import styled from 'styled-components';

export const LoadingStyled = styled.div`
  .theme_standard_loading {

  }
`;
